import withBookingCurrency from 'components/queries/withBookingCurrencyQuery';
import { withUser } from 'components/queries/GetUserQuery';

import ExchangeConfirmation from './ExchangeConfirmation';

export default withUser(withBookingCurrency(ExchangeConfirmation));
